var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 92,
    viewBox: "0 0 492 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_4311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.145 44.2771H326.445C335.671 44.2771 342.076 48.9336 342.076 56.7699V56.8763C342.076 65.4776 334.509 69.8881 325.689 69.8881H314.289V85.1083H311.145V44.2771ZM325.799 67.0542C333.614 67.0542 338.932 63.0629 338.932 57.0759V56.9761C338.932 50.4636 333.828 47.1043 326.232 47.1043H314.289V67.0609L325.799 67.0542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.944 43.9645H373.985L393.634 85.1083H390.132L384.814 73.6666H359.984L354.556 85.1083H351.302L370.944 43.9645ZM383.541 70.9392L372.464 47.3238L361.284 70.9392H383.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.858 44.2771H420.553C425.762 44.2771 429.883 45.8537 432.38 48.2684C433.419 49.2752 434.241 50.4704 434.801 51.7855C435.361 53.1006 435.646 54.5097 435.641 55.9317V56.0648C435.641 62.8833 430.426 66.7682 423.257 67.7128L437.155 85.1349H433.247L419.783 68.2383H406.023V85.1349H402.872L402.858 44.2771ZM420.223 65.4777C427.282 65.4777 432.49 62.0185 432.49 56.1646V56.0648C432.49 50.6033 428.039 47.1375 420.333 47.1375H406.009V65.5043L420.223 65.4777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38 44.2838H449.524V71.0456L476.335 44.2838H480.683L462.224 62.3312L481.44 85.1084H477.312L460.057 64.4333L449.524 74.7177V85.1084H446.38V44.2838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 89.4788H152.237V92H492V89.4788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.643 44.1241H161.787V70.9924L188.598 44.1241H192.939L174.487 62.1782L193.702 84.9487H189.574L172.21 64.2737L161.787 74.558V84.9487H158.643V44.1241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.079 44.1241H202.928V84.9487H206.079V44.1241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.304 44.1241H218.345L247.433 79.6004V44.1241H250.364V84.9487H248.086L218.345 48.7408V84.9487H215.304V44.1241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.588 64.7127V64.6062C259.588 53.4838 268.05 43.5121 280.86 43.5121C293.561 43.5121 301.92 53.2709 301.92 64.4V64.6062C301.92 75.7354 293.451 85.6006 280.75 85.6006C268.05 85.6006 259.588 75.8218 259.588 64.7127ZM298.769 64.7127V64.6062C298.769 54.5348 291.201 46.2395 280.75 46.2395C270.3 46.2395 262.863 54.3219 262.863 64.4V64.6062C262.863 74.6843 270.431 82.8732 280.881 82.8732C291.332 82.8732 298.769 74.7908 298.769 64.7127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 36.78H152.237V39.3012H492V36.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.789 60.9632C142.789 71.7286 133.753 80.5126 122.536 80.5126C111.319 80.5126 102.283 71.7286 102.283 60.9632C102.283 50.1978 111.319 41.4138 122.536 41.4138C133.753 41.4138 142.789 50.1978 142.789 60.9632Z",
    fill: "#E6652C",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.411 52.9147C119.411 68.1251 106.649 80.5126 90.8344 80.5126C75.02 80.5126 62.2578 68.1251 62.2578 52.9147C62.2578 37.7042 75.02 25.3168 90.8344 25.3168C106.649 25.3168 119.411 37.7042 119.411 52.9147Z",
    fill: "#FDB73A",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9897 40.7563C83.9897 62.6816 65.5977 80.5126 42.8386 80.5126C20.0795 80.5126 1.6875 62.6816 1.6875 40.7563C1.6875 18.8309 20.0795 1 42.8386 1C65.5977 1 83.9897 18.8309 83.9897 40.7563Z",
    fill: "#73A050",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8389 57.1958V90.4173M89.7718 66.055V90.4173M122.891 76.7831V90.4173",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_4311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 492,
    height: 92,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23a6bb68ce9f0c7b5b836a0c966e709a.svg";
export { ForwardRef as ReactComponent };